import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Component } from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import DOM from './supplier';

class SupplierPage extends Component {
    constructor(props) {
        super(props);
        this.view = DOM;

        this.state = {
            name: parseInt(props.params.id, 10) ? `#${props.params.id}` : 'New Supplier/Manufacturer',
            modalAddProductVisible: false,
            toolbar: this.getToolbar(parseInt(props.params.id, 10))
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ toolbar: this.getToolbar(parseInt(nextProps.params.id, 10)) });
    }

    // Generate toolbar based on id
    getToolbar = (id) => {
        const toolbar = [];
        if (id) {
            toolbar.push({
                id: 'actionAdd',
                caption: 'Add product',
                icon: 'new-order',
                onClick: () => { this.setModalAddProductVisible(true); }
            });
        }
        toolbar.push({ id: 'actionSave', caption: 'Save', icon: 'save', onClick: this.handleFormSubmit });

        return toolbar;
    }

    // Handle toggle modal add supplier product visibility
    setModalAddProductVisible = modalAddProductVisible => this.setState({ modalAddProductVisible });

    // Handle set page name
    setPageName = name => this.setState({ name });

    // Handle submit update supplier form
    handleFormSubmit = () => this.props.actions.submit('update-supplier');

    render() {
        return this.view();
    }
}

SupplierPage.propTypes = {
    actions: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                submit
            },
            dispatch
        )
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SupplierPage);
